import config from 'config';

const domainScriptId = config.ONETRUST_DOMAIN_SCRIPT_ID?.trim();

/**
 * OneTrust serves the stub from a different URL for test vs production
 * domain scripts (per the OneTrust Cookie Consent Guidelines):
 * - test ids (suffixed `-test`) load from the per-id, uncached `consent/{id}`
 *   path;
 * - production ids load from the shared `scripttemplates` path.
 *
 * Using the production path with a test id fails to resolve the tenant config.
 */
function resolveStubSrc(id: string): string {
  return id.endsWith('-test')
    ? `https://cdn.cookielaw.org/consent/${id}/otSDKStub.js`
    : 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
}

/**
 * The OneTrust loading-script stub. It is strictly-necessary (category C0001),
 * so it loads unconditionally and first — ahead of any tracker — whenever a
 * domain-script id is configured.
 *
 * The `data-domain-script` id is environment-specific (distinct test vs prod
 * values) and supplied via configuration.
 */
export const oneTrustScript: React.JSX.IntrinsicElements['script'] | undefined =
  domainScriptId
    ? ({
        src: resolveStubSrc(domainScriptId),
        type: 'text/javascript',
        async: true,
        'data-domain-script': domainScriptId,
      } as React.JSX.IntrinsicElements['script'])
    : undefined;
